import { Divider, Stack, Typography } from "@mui/material";
import { WebReport2SASRiskData } from "..";
import { NumberTitle, RiskLabel, RiskProps } from "../commons";
import { ODI3RiskLevelChart } from "../DiseaseRiskLevelChart";

export interface SASRiskProps extends RiskProps, WebReport2SASRiskData {}
export default function SASRisk({
  type,
  title,
  summary,
  description_lines,
  ODI_3_percent: odi3,
}: SASRiskProps) {
  return (
    <>
      <Stack sx={{ mx: 6, gap: 4, mb: 12 }}>
        <NumberTitle number={1}>睡眠時無呼吸症候群のリスク</NumberTitle>
        <RiskLabel type={type} title={title} summary={summary} />
        <Typography variant="body1" textAlign="justify" color="text.primary">
          {description_lines}
        </Typography>
      </Stack>
      <Divider sx={{ mx: 6 }} />
      <Stack sx={{ mx: 6, gap: 4, mt: 6.5, mb: 12 }}>
        <Typography variant="subtitle1">
          血中酸素飽和度の降下指数<sup>※</sup>
        </Typography>
        <Stack gap={4}>
          <Stack>
            <ODI3RiskLevelChart odi3Score={odi3} />
          </Stack>
          <Stack alignItems="center">
            <Stack direction="row" gap={2}>
              <Typography variant="caption" fontWeight={500} fontSize="12px">
                リスクの程度：
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  "&::before": {
                    content: "'■'",
                    marginRight: 1,
                    color: "#7FAACF",
                  },
                }}
              >
                低い
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  "&::before": {
                    content: "'■'",
                    marginRight: 1,
                    color: "#FFCE80",
                  },
                }}
              >
                中
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  "&::before": {
                    content: "'■'",
                    marginRight: 1,
                    color: "#FF9C97",
                  },
                }}
              >
                高い
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  "&::before": {
                    content: "'■'",
                    marginRight: 1,
                    color: "#FF756E",
                  },
                }}
              >
                非常に高い
              </Typography>
            </Stack>
          </Stack>

          <Typography variant="caption" color="#707070">
            ※SpO<sub>2</sub>
            が基準値から3％以上降下した1時間あたりの回数を示します。
          </Typography>
        </Stack>
        <Divider />
      </Stack>
    </>
  );
}
